module.exports = __webpack_public_path__ + "img/b7.0cb2143a.png";